import * as msal from '@azure/msal-browser'

let accessToken
let msalApp

export default {
    async configure() {
        if (msalApp) {
            return
        }
        const config = {
            auth: {
                clientId: process.env.VUE_APP_MICROSOFT_CLIENT_ID,
                redirectUri: window.location.origin,
                authority: 'https://login.microsoftonline.com/common',
            },
            cache: {
                cacheLocation: 'localStorage',
            },
        }

        msalApp = new msal.PublicClientApplication(config)
    },

    async login(scopes = ['Contacts.Read', 'User.Read']) {
        if (!msalApp) {
            return
        }
        await msalApp.loginPopup({
            scopes,
            prompt: 'select_account',
        })
    },

    logout() {
        if (!msalApp) {
            return
        }

        msalApp.logoutPopup()
    },

    user() {
        if (!msalApp) {
            return null
        }

        const currentAccounts = msalApp.getAllAccounts()
        if (!currentAccounts || currentAccounts.length === 0) {
            return null
        } else if (currentAccounts.length > 1) {
            return currentAccounts[0]
        } else {
            return currentAccounts[0]
        }
    },

    async acquireToken(scopes = ['Contacts.Read', 'User.Read']) {
        if (!msalApp) {
            return null
        }
        const accessTokenRequest = {
            scopes,
            account: this.user(),
        }

        let tokenResp
        try {
            tokenResp = await msalApp.acquireTokenSilent(accessTokenRequest)
        } catch (err) {
            tokenResp = await msalApp.acquireTokenPopup(accessTokenRequest)
        }

        if (!tokenResp.accessToken) {
            return null
        }
        return tokenResp.accessToken
    },

    clearLocal() {
        if (msalApp) {
            for (let entry of Object.entries(localStorage)) {
                let key = entry[0]
                if (key.includes('login.windows')) {
                    localStorage.removeItem(key)
                }
            }
        }
    },

    isConfigured() {
        return msalApp != null
    },
    getAccessToken() {
        return accessToken
    },

    async getOutlookContactPhoto(id) {
        let resp
        try {
            resp = await this.callGraph(`/me/contacts/${id}/photo/$value`)

            if (resp) {
                const blob = await resp.blob()
                if (blob) {
                    const image = URL.createObjectURL(blob)
                    if (image) {
                        return image
                    }
                }
            }
        } catch {
            return null
        }
    },

    async getOutlookContacts() {
        let resp = await this.callGraph('/me/contacts/?$top=400')
        if (resp) {
            let data = await resp.json()
            if (data) {
                return data
            }
        }
    },

    async callGraph(apiPath) {
        this.accessToken = await this.acquireToken(['Contacts.Read', 'user.read'])

        let resp = await fetch(`${'https://graph.microsoft.com/v1.0'}${apiPath}`, {
            headers: { authorization: `bearer ${this.accessToken}` },
        })

        if (!resp.ok) {
            throw new Error(`Call to ${'https://graph.microsoft.com/v1.0'}${apiPath} failed: ${resp.statusText}`)
        }

        return resp
    },
}
